<template>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <h2 class="text-left mb-0">{{ $t('dpbVault.title') }}</h2>
                            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap">
                                <b-button
                                    @click="tab === 'active' || tab === 'review' ? $router.push('/dpb-vault/add') : $bvModal.show('add-update-doc-type-modal')"
                                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                    variant="primary">
                                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                                    <p class="mb-0 ml-2 text-white">{{ tab === 'active' || tab === 'review' ? $t('dpbVault.addDocument') : $t('dpbVault.addDocType') }}</p>
                                </b-button>
                                <b-dropdown v-if="selectedRows.length" id="dropdown-divider" text="text"
                                    class="load-dropdown-2">
                                    <template slot="button-content">
                                        <b-icon class="dots" icon="three-dots"></b-icon>
                                    </template>
                                    <b-dropdown-item-button class="mb-0" @click="downloadAllDocs()">
                                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('dpbVault.downloadDocs', { count: selectedRows.length }) }}</p>
                                    </b-dropdown-item-button>
                                </b-dropdown>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="data-table team-data-table table-custom-border">
                            <div class="bg-white rounded">
                                <div v-if="!isTableMounted" class="d-flex align-items-center px-3 py-3">
                                    <b-skeleton v-for="n in 3" :key="`vault-tab-skeleton-${n}`" width="80px" height="26px"
                                        class="mr-3 mb-0"></b-skeleton>
                                </div>
                                <v-tabs v-else class="team-tabs mb-0" show-arrows>
                                    <v-tab @click="setTabType('active')">{{ $t('dpbVault.tabActive') }} <span class="f-12 ml-1"> ({{ counts.active ?
                                        counts.active : 0
                                    }})</span></v-tab>
                                    <v-tab class="with-border" @click="setTabType('review')">{{ $t('dpbVault.tabReview') }} <span class="f-12 ml-1">
                                            ({{
                                                counts.review ?
                                                counts.review : 0 }})</span></v-tab>
                                    <v-tab @click="setTabType('docTypes')">{{ $t('dpbVault.tabDocTypes') }}</v-tab>
                                </v-tabs>
                            </div>
                            <div class="bg-white pt-3 pt-sm-4 rounded">
                                <div class="table_row team_table_row">
                                    <div class="equipment-border filter-box" v-if="isTableMounted">
                                        <div class="d-flex mb-4 px-3 px-sm-4">
                                            <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                                <b-input-group class="username-input-field">
                                                    <b-form-input type="text" :placeholder="$t('dpbVault.search')"
                                                        v-model="filterFields.search" class="unit f-12"
                                                        @keyup.enter="getVaultData()"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button variant="primary" @click="getVaultData()">
                                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                            <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                                <div class="position-relative">
                                                    <div class="position-absolute notification-badge"
                                                        v-if="activeFiltersCount">
                                                        {{ activeFiltersCount }}
                                                    </div>
                                                    <button class="btn btn-filter-section"
                                                        @click="$bvModal.show('modal-filter')">
                                                        <div class="d-flex align-items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                                stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                class="lucide lucide-sliders-horizontal w-4 h-4"
                                                                data-id="element-964">
                                                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                                                <line x1="16" x2="16" y1="18" y2="22"></line>
                                                            </svg>
                                                            <p class="mb-0 ml-2">{{ $t('dpbVault.filters') }}</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="!isTableMounted" class="mt-2"
                                        style="height: calc(100vh - 240px); overflow: hidden;">
                                        <b-skeleton-table :rows="17" :columns="7"
                                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                    </div>
                                    <b-table v-else ref="tableRef" class="mt-2" responsive :sticky-header="'calc(100vh - 330px)'"
                                        :fields="fields" :items="items" hover :current-page="currentPage"
                                        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
                                        :busy.sync="isBusy" selectable select-mode="multi" no-select-on-click
                                        @row-selected="onRowSelected" :show-empty="emptyTable">
                                        <template #head(selected)="">
                                            <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)"
                                                v-model="allRowsSelected">
                                            </b-form-checkbox>
                                        </template>
                                        <template #cell(selected)="data">
                                            <b-form-checkbox class="pl-0 w-fit-content"
                                                @change="checked(data.index, data.rowSelected)" v-model="data.rowSelected">
                                            </b-form-checkbox>
                                        </template>
                                        <template #cell(notify_expiry)="data">
                                            <span>{{ data.value ? $t('dpbVault.yes') : $t('dpbVault.no') }}</span>
                                        </template>
                                        <template #cell(action)="data">
                                            <div v-if="tab !== 'docTypes'">
                                                <svg @click="$router.push({ name: 'UpdateDPBVaultDoc', params: { id: data.item.id } })"
                                                    class="cursor-pointer mr-4" width="20" height="15" viewBox="0 0 20 15"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="downloadDoc(data.item)" class="mr-4 cursor-pointer" width="20"
                                                    height="20" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>

                                                <svg @click="showVaultDeletePopup(data.item.id)" class="cursor-pointer"
                                                    width="19" height="20" viewBox="0 0 19 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div v-else>
                                                <svg @click="setDocTypeData(data.item)" class="cursor-pointer mr-4"
                                                    width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M4.48009 13.575L11.7753 6.2798L8.3102 2.81474L1.01503 10.1099C0.914596 10.2105 0.843253 10.3363 0.808568 10.4742L0 14.59L4.11506 13.7814C4.25322 13.7469 4.37961 13.6755 4.48009 13.575ZM14.1303 3.92475C14.4247 3.63033 14.59 3.23105 14.59 2.81474C14.59 2.39842 14.4247 1.99915 14.1303 1.70472L12.8853 0.459685C12.5909 0.165349 12.1916 0 11.7753 0C11.3589 0 10.9597 0.165349 10.6652 0.459685L9.42021 1.70472L12.8853 5.16979L14.1303 3.92475Z"
                                                        fill="#2CCE89" />
                                                </svg>
                                                <svg @click="showDocTypeDeletePopup(data.item.id)" class="cursor-pointer"
                                                    width="19" height="20" viewBox="0 0 19 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </template>
                                    </b-table>
                                    <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                                        <div class="d-flex align-items-center flex-wrap">
                                            <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                <b-form-select v-model="perPage" :options="pageOptions" />
                                            </div>
                                            <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                                            <div class="pagination">
                                                <b-pagination v-model="currentPage" :total-rows="rows"
                                                    :per-page="perPage"></b-pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <DeleteModal :message="$t('dpbVault.deleteDocConfirm')" v-if="showDocumentDeleteModal"
            @confirm="deleteDocumentItem($event)" />
        <DeleteModal :message="$t('dpbVault.deleteDocTypeConfirm')" v-if="showDocTypeDeleteModal"
            @confirm="deleteDocTypeItem($event)" />
        <AddAndUpdateDocType @refreshDocTypes="getVaultData()" :docTypeData="docTypeData" @reset="docTypeData = null" />
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('dpbVault.filtersModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('dpbVault.docTypeLabel')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="docTypeOptions" :reduce="(option) => option.id"
                        @search="searchDocType" v-model="filterFields.doc_type" @input="getVaultData()">
                        <span slot="no-options">
                            {{ $t('dpbVault.searchName') }}
                        </span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('dpbVault.nameLabel')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="driverOptions" :reduce="(option) => option.id"
                        @search="searchDriver" v-model="filterFields.name" @input="getVaultData()">
                        <span slot="no-options">
                            {{ $t('dpbVault.searchName') }}
                        </span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('dpbVault.vehicleLabel')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="vehicleOptions" :reduce="(option) => option.id"
                        @search="searchVehicle" v-model="filterFields.vehicle" @input="getVaultData()">
                        <span slot="no-options">
                            {{ $t('dpbVault.searchName') }}
                        </span>
                    </v-select>
                </b-form-group>
                <b-form-group :label="$t('dpbVault.trailerLabel')" class="text-left w-equipment-box mb-0">
                    <v-select class="f-12 bg-grey" :options="trailerOptions" :reduce="(option) => option.id"
                        @search="searchTrailer" v-model="filterFields.trailer" @input="getVaultData()">
                        <span slot="no-options">
                            {{ $t('dpbVault.searchName') }}
                        </span>
                    </v-select>
                </b-form-group>

            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('dpbVault.reset') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                        @click="$bvModal.hide('modal-filter')">{{ $t('dpbVault.close') }}</b-button>
                </div>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapActions } from "vuex";
import * as moment from "moment-timezone";
import DeleteModal from "@/components/DeleteModal.vue";
import AddAndUpdateDocType from "@/components/DPBVault/AddAndUpdateDocType.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import JSZip from "jszip"

export default {
    name: "dpb-vault",
    components: {
        DeleteModal,
        AddAndUpdateDocType,
        vSelect
    },
    data() {
        return {
            isTableMounted: false,
            positionText: "",
            allRowsSelected: false,
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            docTypeOptions: [],
            emptyTable: false,
            isBusy: false,
            tab: "active",
            sortDesc: undefined,
            sortBy: undefined,
            items: [],

            counts: {
                active: 0,
                review: 0
            },
            showDocumentDeleteModal: false,
            showDocTypeDeleteModal: false,
            itemId: null,
            docTypeData: null,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            selectedRows: [],
            filterFields: {
                search: "",
                name: "",
                trailer: '',
                vehicle: '',
                doc_type: ''
            },
            perPage: 25,
            currentPage: 1,
            rows: 1
        };
    },
    watch: {
        perPage: {
            async handler() {
                await this.getVaultData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getVaultData();
            },
        },
        sortBy: {
            async handler() {
                await this.getVaultData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getVaultData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
    computed: {
        fields() {
            if (this.tab === 'docTypes') {
                return [
                    { key: "type", thClass: 'font-table-weight-bold', label: this.$t('dpbVault.columnName'), sortable: true },
                    { key: "notify_expiry", thClass: 'font-table-weight-bold', label: this.$t('dpbVault.columnExpNotify'), sortable: true },
                    { key: "action", label: this.$t('dpbVault.columnAction'), sortable: false }
                ]
            }
            return [
                {
                    key: "selected",
                    label: "",
                    sortable: false,
                    thStyle: { minWidth: "20px", width: "20px" }
                },
                { key: "date", label: this.$t('dpbVault.columnDate'), thClass: 'font-table-weight-bold', stickyColumn: true, sortable: true },
                { key: "doc_type", label: this.$t('dpbVault.columnDocType'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "description", label: this.$t('dpbVault.columnDescription'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "name", label: this.$t('dpbVault.columnName'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "vehicle", label: this.$t('dpbVault.columnVehicle'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "trailer", label: this.$t('dpbVault.columnTrailer'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "expiry_date", label: this.$t('dpbVault.columnExpiryDate'), thClass: 'font-table-weight-bold', sortable: true },
                { key: "action", label: this.$t('dpbVault.columnAction'), thClass: 'font-table-weight-bold', sortable: true },
            ]
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
    },
    methods: {
        ...mapActions(["getFilteredDrivers", "getFilteredEquipments", "getDPBVaultData", "deleteVaultRecord", "setLoader", "setNotification", "getDPBVaultDocTypeData", "deleteVaultDocTypeRecord", "getDPBVaultDataById"]),
        async searchDriver(searchText) {
            if (searchText && searchText.length >= 2) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchDocType(searchText) {
            if (searchText) {
                let options = [];
                const { data } = await this.getDPBVaultDocTypeData({ url: `search=${searchText}&search_list=type` });
                data.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.type,
                    });
                });
                this.docTypeOptions = this.docTypeOptions.concat(options)
                this.docTypeOptions = [...new Map(this.docTypeOptions.map(item => [item['id'], item])).values()]
            }
        },

        async searchVehicle(searchText) {
            if (searchText) {
                let options = [];
                const vehicleRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle" });
                vehicleRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.vehicleOptions = this.vehicleOptions.concat(options)
                this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                let options = [];
                const trailerRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer" });
                trailerRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.trailerOptions = this.trailerOptions.concat(options)
                this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
            }
        },
        async downloadAllDocs() {
            try {
                this.setLoader(true);
                const mainZip = new JSZip();

                for (const [index, row] of this.selectedRows.entries()) {
                    const { documents } = await this.getDPBVaultDataById(row.id);
                    if (documents && documents.length > 0) {
                        const docZip = new JSZip();
                        for (const doc of documents) {
                            const response = await fetch(doc.file);
                            if (!response.ok) continue;
                            const blob = await response.blob();
                            const fileUrl = doc.file.split('?')[0];
                            const fileName = fileUrl.split('/').pop();
                            docZip.file(fileName, blob);
                        }
                        const docZipBlob = await docZip.generateAsync({ type: 'blob' });
                        mainZip.file(`${row.doc_type || 'document'}-${moment().format("YYYY-MM-DD")}-${index}.zip`, docZipBlob);
                    }
                }

                const finalZip = await mainZip.generateAsync({ type: 'blob' });
                const url = window.URL.createObjectURL(finalZip);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Vault-Documents-${moment().format("YYYY-MM-DD")}.zip`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
                this.setLoader(false);
            } catch (e) {
                this.setLoader(false);
                console.log(e);
            }
        },
        checked(index, checked) {
            let tableRef = this.$refs.tableRef
            if (checked === true) tableRef.selectRow(index)
            else tableRef.unselectRow(index)
        },
        selectRows(checked) {
            if (checked) {
                this.$refs.tableRef.selectAllRows()
            }
            else {
                this.$refs.tableRef.clearSelected()
                this.allRowsSelected = false
            }
        },
        setDocTypeData(data) {
            this.docTypeData = data
            this.$bvModal.show('add-update-doc-type-modal')
        },
        async downloadDoc(data) {
            try {
                this.setLoader(true)
                const { documents } = await this.getDPBVaultDataById(data.id);
                if (documents && documents.length > 0) {
                    const zip = new JSZip();
                    const folder = zip.folder(`${data.doc_type}`);
                    const fetchPromises = documents.map((doc) =>
                        fetch(doc.file)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                return response.blob();
                            })
                            .then(blob => {
                                const fileUrl = doc.file.split('?')[0];
                                const fileName = fileUrl.split('/').pop();
                                folder.file(fileName, blob);
                            })
                    );
                    await Promise.all(fetchPromises);
                    const content = await zip.generateAsync({ type: 'blob' });
                    const newUrl = window.URL.createObjectURL(content);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    a.download = `${data.doc_type}-${moment().format("YYYY-MM-DD")}.zip`;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                }
                else {
                    this.setLoader(false)
                }
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async deleteDocumentItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteDocument(this.itemId);
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                }
            }
            this.showDocumentDeleteModal = false;
        },
        async deleteDocument(id) {
            try {
                await this.deleteVaultRecord(`${id}/`);
                await this.getVaultData();
                await this.setNotification({
                    msg: this.$t('dpbVault.documentDeleted'),
                    type: "success",
                    color: "green",
                });
                this.itemId = null;
            } catch (error) {
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async deleteDocTypeItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteDocType(this.itemId);
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                }
            }
            this.showDocTypeDeleteModal = false;
        },
        async deleteDocType(id) {
            try {
                await this.deleteVaultDocTypeRecord(`${id}/`);
                await this.getVaultData();
                await this.setNotification({
                    msg: this.$t('dpbVault.docTypeDeleted'),
                    type: "success",
                    color: "green",
                });
                this.itemId = null;
            } catch (error) {
                await this.setNotification({
                    msg: error.error ? error.error : error,
                    type: "error",
                    color: "red",
                });
            }
        },
        showVaultDeletePopup(id) {
            this.showDocumentDeleteModal = true;
            this.itemId = id;
        },
        showDocTypeDeletePopup(id) {
            this.showDocTypeDeleteModal = true;
            this.itemId = id;
        },
        setTabType(tab) {
            this.tab = tab
            this.currentPage = 1
            this.getVaultData()
        },
        onRowSelected(items) {
            this.selectedRows = items
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                name: '',
                trailer: '',
                vehicle: '',
                doc_type: ''
            }
            await this.getVaultData();
        },
        async getVaultData() {
            try {
                this.items = []
                this.isBusy = true
                let data = null
                let url = ""
                this.allRowsSelected = false
                this.selectedRows = []
                 Object.keys(this.filterFields).map((key) => {
                    if (key === 'search' && this.filterFields['search'] !== "") {
                        let searchList = "name,trailer,vehicle,date,expiry_date,doc_type,description"
                        url += `${key}=${encodeURIComponent(this.filterFields[key])}&search_list=${searchList}&`
                    }
                    else if (this.filterFields[key]) {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=date&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}&tab=${this.tab}`
                if (this.tab === 'active' || this.tab === 'review') {
                    data = await this.getDPBVaultData({ url });
                    this.counts.active = data.counts.Active
                    this.counts.review = data.counts.Review
                }
                else data = await this.getDPBVaultDocTypeData({ url });
                if (data.total_entries_count) {
                    this.rows = data.total_entries_count
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('dpbVault.positionText', { start, end, total: data.total_entries_count })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('dpbVault.emptyPosition')
                }
                data.data.forEach((item) => {
                    if (this.tab === 'docTypes') {
                        this.items.push({
                            id: item.id,
                            type: item.type ? item.type : '-',
                            notify_expiry: item.notify_expiry
                        })
                    }
                    else {
                        let color;
                        if (item.expiry_date) {
                            const currentDate = new Date();
                            const expiryDate = new Date(item.expiry_date);
                            const diffDays = parseInt(
                                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                                10
                            );
                            if (diffDays > 30) {
                                color = "color:black";
                            } else if (diffDays <= 30 && diffDays >= 1) {
                                color = "color:#FFC800";
                            } else color = "color:#FF0000";

                        }
                        this.items.push({
                            id: item.id,
                            date: item.date ? moment(item.date).format("ll") : '-',
                            doc_type: item.doc_type ? item.doc_type.type : '-',
                            description: item.description ? item.description : '-',
                            name: item.driver ? item.driver.name : '-',
                            vehicle: item.vehicle ? item.vehicle.unit_no : '-',
                            trailer: item.trailer ? item.trailer.unit_no : '-',
                            expiry_date: item.expiry_date ? moment(item.expiry_date).format("ll") : '-',
                            expiry_color: color
                        })
                    }
                })
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isTableMounted = true
                this.isBusy = false
                console.log(e)
            }
        }
    },
    async mounted() {

    },
};
</script>